<template>
	
</template>
<script>
	export default {
		created(){
			this.run();
		},
		methods:{
			run(){
                var _this=this
				_this.$router.push('/');
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/verification.vue